import "./App.css";
import { Routes } from "./Routes/Route";

function App() {
  return (
    <div className="App">
      {/* <SearchResultPage /> */}
      <Routes />
    </div>
  );
}

export default App;
